import { styled } from 'styled-components';
import { IGlobaVariables } from './../../../components/Layout/styles';
import { IFooter1, defaultParams } from './params';

const Styles = styled.footer<{
  theme?: IGlobaVariables;
  $config: IFooter1;
}>`
  .footer {
    background-color: ${({ $config: styles }) => styles.backgroundColor};

    &-wrapper {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 40px;
      padding: 45px 0 20px;
    }

    &-copyright {
      order: 2;
      flex-shrink: 0;
      color: ${({ $config: styles }) => styles.group_copyright.color};
      font-family: ${({ $config: styles }) => styles.group_copyright.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_copyright.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_copyright.fontSize};
      line-height: ${({ $config: styles }) => styles.group_copyright.lineHeight};
      font-style: ${({ $config: styles }) => styles.group_copyright.fontStyle};
    }

    &-navlinks {
      order: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 30px;

      a {
        flex-shrink: 0;
        color: ${({ $config: styles }) => styles.group_navlinks.color};
        font-family: ${({ $config: styles }) => styles.group_navlinks.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_navlinks.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_navlinks.fontSize};
        line-height: ${({ $config: styles }) => styles.group_navlinks.lineHeight};
        font-style: ${({ $config: styles }) => styles.group_navlinks.fontStyle};
        text-decoration: ${({ $config: styles }) => styles.group_navlinks.textDecoration};

        &:hover {
          color: ${({ $config: styles }) => styles.group_navlinks.hover_color};
          text-decoration: ${({ $config: styles }) => styles.group_navlinks.hover_textDecoration};
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    .footer {
      &-wrapper {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        min-height: 80px;
      }

      &-copyright {
        order: 1;
      }

      &-navlinks {
        order: 2;
        flex-direction: row;
        justify-content: flex-end;
      }
    }
  }
`;

export default Styles;
